import {
    AUTHORIZING_NETSUITE_REQUEST, AUTHORIZING_NETSUITE_SUCCEDDED, AUTHORIZING_NETSUITE_FAILED,
    AUTHENTICATING_NETSUITE_REQUEST, AUTHENTICATING_NETSUITE_SUCCEDDED, AUTHENTICATING_NETSUITE_FAILED,
    FETCHING_NETSUITE_INTEGRATION_REQUEST, FETCHING_NETSUITE_INTEGRATION_SUCCEDDED, FETCHING_NETSUITE_INTEGRATION_FAILED,
    UPDATING_NETSUITE_REQUEST, UPDATING_NETSUITE_SUCCEDDED, UPDATING_NETSUITE_FAILED,
    DEACTIVATING_NETSUITE_INTEGRATION_REQUEST, DEACTIVATING_NETSUITE_INTEGRATION_SUCCEDDED, DEACTIVATING_NETSUITE_INTEGRATION_FAILED, INTEGRATION_AUTH_EXPIRED
} from '../actionTypes.jsx';
import axios from 'axios';
import {activatingIntegrationSuccedded, fetchingIntegrationSuccedded, deactivatingIntegrationSuccedded, 
  integrationAuthExpired } from '../integrations';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const NETSUITE_BASE_URL = `${apiUrl}/api/2.0/integrations/netsuite`;

export function authorizeAccount(clientId, clientSecret) {
  return function (dispatch) {
    dispatch(authorizingAccount());

    const url = `${NETSUITE_BASE_URL}/authorize`;
    
    const data = {
      clientId: clientId,
      clientSecret: clientSecret
    } 

    return axios({
      method: 'POST',
      url: url,
      data: data
    })
    .then((response) => {
      dispatch(authorizingAccountSucceeded(response.data));
    })
    .catch(error =>
      dispatch(authorizingAccountFailed(error.errors))
    )
  }
}

function authorizingAccount(){
  return {
    type: AUTHORIZING_NETSUITE_REQUEST,
    payload: {}
  }
}

function authorizingAccountSucceeded(url){
  return {
    type: AUTHORIZING_NETSUITE_SUCCEDDED,
    payload: url
  }
}

function authorizingAccountFailed(error){
  return {
    type: AUTHORIZING_NETSUITE_FAILED,
    payload: error
  }
}

export function authorizeAccountByIntegration(integrationId) {
  return function (dispatch) {
    dispatch(authorizingAccount());

    const url = `${NETSUITE_BASE_URL}/${integrationId}/authorize`;

    return axios({
      method: 'POST',
      url: url
    })
    .then((response) => {
      dispatch(authorizingAccountSucceeded(response.data));
    })
    .catch(error =>
      dispatch(authorizingAccountFailed(error.errors))
    )
  }
}

export function authenticateAccount(code, company, entity, clientId, clientSecret){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      company: company,
      code: code,
      entity: entity,
      clientId: clientId,
      clientSecret: clientSecret
    }

    return axios({
      method: 'POST',
      url: NETSUITE_BASE_URL,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}
  
function authenticatingAccount(){
  return {
    type: AUTHENTICATING_NETSUITE_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_NETSUITE_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_NETSUITE_FAILED,
    payload: error
  }
}

/**
* Fetch Netsuite integration
*/
export function fetchNetsuiteIntegration() {
  return function (dispatch) {
    dispatch(fetchingNetsuiteIntegration());

    return axios({
      method: 'GET',
      url: NETSUITE_BASE_URL
    })
    .then((response) => {
      dispatch(fetchingNetsuiteIntegrationSuccedded(response.data));
      dispatch(fetchingIntegrationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      console.log({error});
      dispatch(fetchingNetsuiteIntegrationFailed(error.errors))
    })
  }
}

function fetchingNetsuiteIntegration() {
  return {
    type: FETCHING_NETSUITE_INTEGRATION_REQUEST,
    payload: {}
  }
}

function fetchingNetsuiteIntegrationSuccedded(json) {
  return {
    type: FETCHING_NETSUITE_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function fetchingNetsuiteIntegrationFailed(error) {
  return {
    type: FETCHING_NETSUITE_INTEGRATION_FAILED,
    payload: error
  }
}

/**
* Update netsuite configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: NETSUITE_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, 'netsuite'));
      dispatch(updatingConfigurationFailed(error.errors))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_NETSUITE_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_NETSUITE_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_NETSUITE_FAILED,
    payload: error
  }
}

/**
* Deactivate netsuite configuration
*/

export function deactivateNetsuiteIntegration(integrationType){
  return function (dispatch) {
    dispatch(deactivatingNetsuiteIntegration());
    
    return axios({
      method: 'DELETE',
      url: NETSUITE_BASE_URL,
      params: {type: 'user'}
    })

    .then((response) => {
      dispatch(deactivatingNetsuiteIntegrationSuccedded({type: integrationType,data:response.data}));
      dispatch(deactivatingIntegrationSuccedded({type: integrationType,data:response.data}));
    })
    .catch(error =>
      dispatch(deactivatingNetsuiteIntegrationFailed(error.errors))
    )
  }
}

function deactivatingNetsuiteIntegration(){
  return {
    type: DEACTIVATING_NETSUITE_INTEGRATION_REQUEST,
    payload: {}
  }
}

function deactivatingNetsuiteIntegrationSuccedded(json){
  return {
    type: DEACTIVATING_NETSUITE_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function deactivatingNetsuiteIntegrationFailed(error){
  return {
    type: DEACTIVATING_NETSUITE_INTEGRATION_FAILED,
    payload: error
  }
}
